import './App.css';
import Homepage from "./pages/Homepage";
import WhenItDrop from "./pages/WhenItDrop";
import RMM from "./pages/RMM";
import AdoptMe from "./pages/AdoptMe";
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Homepage/>}/>
                <Route path="/projects/when-it-drop" element={<WhenItDrop/>}/>
                <Route path="/projects/remember-my-medicines" element={<RMM/>}/>
                <Route path="/projects/adopt-me" element={<AdoptMe/>}/>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
